import { group, seg } from './ToggleGroup.css';

interface Option<T extends string> { value: T; label: string; }

interface ToggleGroupProps<T extends string> {
  value: T;
  options: Option<T>[];
  onChange: (value: T) => void;
  ariaLabel: string;
}

export function ToggleGroup<T extends string>({ value, options, onChange, ariaLabel }: ToggleGroupProps<T>) {
  return (
    <div className={group} role="radiogroup" aria-label={ariaLabel}>
      {options.map(o => (
        <button key={o.value} type="button" role="radio" aria-checked={value === o.value}
                className={seg} onClick={() => onChange(o.value)}>
          {o.label}
        </button>
      ))}
    </div>
  );
}
